export default __webpack_public_path__ + "static/media/thum3.b3885f2b.jpg";